"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelPageWithInFlightBox = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var journey_model_1 = require("@athena-portal/journey-model");
var services_1 = require("@falcon/services");
var CancelPageWithInFlightBox = exports.CancelPageWithInFlightBox = /** @class */ (function (_super) {
    __extends(CancelPageWithInFlightBox, _super);
    function CancelPageWithInFlightBox(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        if ((_b = (_a = _this.props.interaction.paymentDetails) === null || _a === void 0 ? void 0 : _a.instalmentPlan) === null || _b === void 0 ? void 0 : _b.instalmentPlanParameters) {
            _this.cancellationFee = _this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.cancellationFee;
        }
        else {
            _this.cancellationFee = services_1.productHelper.isHome(_this.props.interaction) ? "30" : "40";
        }
        _this.product = services_1.productHelper.isHome(_this.props.interaction) ? "home" : "car";
        return _this;
    }
    CancelPageWithInFlightBox.prototype.render = function () {
        var inFlightInstalment = this.props.interaction.uistate.inFlightCost;
        var totalPrice = this.props.interaction.factors.returnPremium > 0 ? this.props.interaction.factors.returnPremium : this.props.interaction.factors.additionalPremium;
        var type = this.getSetting("type", undefined);
        var hasClaim = this.getSetting("hasClaim", false);
        return (React.createElement(React.Fragment, null,
            type === "cancelRefundNoFee" &&
                React.createElement("div", { className: "policy-change-price" },
                    React.createElement("div", { id: "price", className: "price font-weight-bold font-family-display text-blue-1" },
                        "\u00A3",
                        this.props.interaction.factors.returnPremium),
                    React.createElement("div", { className: "margin-bottom-32" }, "Your refund is based on the number of days left on the policy after cancellation."),
                    React.createElement("div", { className: "margin-bottom-32" },
                        "You have a payment of \u00A3",
                        inFlightInstalment,
                        " that's already been requested and can\u2019t be changed \u2013 this has been included in the calculation of your refund total, which you\u2019ll get 7-10 working days after your payment goes through.")),
            type === "cancelRefundWithFee" &&
                React.createElement("div", { className: "policy-change-price" },
                    React.createElement("div", { id: "price", className: "price font-weight-bold font-family-display text-blue-1" },
                        "\u00A3",
                        this.props.interaction.factors.returnPremium),
                    React.createElement("div", { className: "margin-bottom-32" },
                        "Your refund is based on the number of days left on the policy after cancellation, minus a \u00A3",
                        this.cancellationFee,
                        " cancellation fee."),
                    React.createElement("div", null,
                        "You have a payment of \u00A3",
                        inFlightInstalment,
                        " that's already been requested and can\u2019t be changed - this has been included in the calculation of your refund total.")),
            type === "outstandingBalance" &&
                React.createElement("div", { className: "policy-change-price" },
                    React.createElement("div", { id: "price", className: "price font-weight-bold font-family-display text-blue-1" },
                        "\u00A3",
                        this.props.interaction.factors.additionalPremium),
                    React.createElement("div", { className: "margin-bottom-32" },
                        "Please settle your outstanding balance for your ",
                        this.product,
                        " policy. This amount is based on a \u00A3",
                        this.cancellationFee,
                        " cancellation fee and the cost of your cover before cancellation."),
                    React.createElement("div", { className: "margin-bottom-32" },
                        "Your upcoming instalment of \u00A3",
                        inFlightInstalment,
                        " has also been taken into account, so this will need to be paid by Direct Debit as usual.")),
            type === "outstandingBalanceWithClaimWithInFlight" &&
                React.createElement("div", { className: "policy-change-price" },
                    React.createElement("div", { id: "price", className: "price font-weight-bold font-family-display text-blue-1" },
                        "\u00A3",
                        this.props.interaction.factors.additionalPremium),
                    React.createElement("div", { className: "margin-bottom-32" },
                        "\u00A3",
                        totalPrice,
                        " you have to pay to cancel your ",
                        this.product,
                        " policy. The price includes a \u00A3",
                        this.cancellationFee,
                        " cancellation fee and the cost of your cover prior to the cancellation date. Please note this calculation includes your next instalment of \u00A3",
                        inFlightInstalment,
                        ". Due to your claim, you're not entitled to a refund.")),
            type === "outstandingBalancePaymentChoiceWording" &&
                React.createElement("div", { className: "policy-change-price" },
                    React.createElement("div", { id: "price", className: "price font-weight-bold font-family-display text-blue-1" },
                        "\u00A3",
                        this.props.interaction.factors.additionalPremium),
                    React.createElement("div", { className: "margin-bottom-32" },
                        React.createElement("span", null,
                            "\u00A3",
                            totalPrice,
                            " left to pay to cancel your ",
                            this.product,
                            " policy. "),
                        React.createElement("span", null,
                            "The price includes a \u00A3",
                            this.cancellationFee,
                            " cancellation fee and the cost of your cover prior to the cancellation date. "),
                        React.createElement("span", null,
                            "Please note this excludes your next instalment of \u00A3",
                            inFlightInstalment,
                            " (incl. Insurance Premium Tax), which we will still take payment for in the next few days. "),
                        hasClaim && React.createElement("span", null, "Due to your claim, you're not entitled to a refund."))),
            React.createElement("div", { className: "warning-banner dashboard-missed-payment-banner mb-0" },
                React.createElement("div", null, "Please do not cancel your Direct Debit until after your payment\u2019s been taken."))));
    };
    CancelPageWithInFlightBox = __decorate([
        (0, journey_model_1.settings)([
            { name: "type", type: journey_model_1.TypeDescriptions.String },
            { name: "inFlightInstalment", type: journey_model_1.TypeDescriptions.String },
            { name: "totalPrice", type: journey_model_1.TypeDescriptions.String },
            { name: "hasClaim", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], CancelPageWithInFlightBox);
    return CancelPageWithInFlightBox;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CancelPageWithInFlightBox.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/CancelPageWithInFlightBox.js
// module id = 3466
// module chunks = 0